export default "__VITE_ASSET__DJMLGUAJ__"